/* unplugin-vue-components disabled */import script from "./recharge_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./recharge_copy.vue?vue&type=script&setup=true&lang=js"

import "./recharge_copy.vue?vue&type=style&index=0&id=2e9784cb&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e9784cb"]])

export default __exports__